import React, { useState } from "react";
import { apiGetInstance, apiUpdateInstance } from "../../../api/ApiInstance";
import { chgInstance } from "../../../redux/ReduxInstance";
import { useSelector, useDispatch } from "react-redux";
import ComponentLoader from "../../layout/ComponentLoader";
import ModalDelete from "./ModalDelete";
import { Button, Image, Form, Alert } from "react-bootstrap";
import { MdZoomIn, MdZoomOut } from "react-icons/md";
//https://www.npmjs.com/package/react-avatar-editor
import AvatarEditor from "react-avatar-editor";
import { useTranslation } from "react-i18next";

const ComponentUpdateApparence = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);

  const [showDelete, setShowDelete] = useState(false);

  const { defaultImg, champ, personnalisation, widthEditor, heightEditor } =
    props;
  const [zoom, setZoom] = useState(1.1);

  const [loader, setLoader] = useState(false);
  const [modeEdit, setModeEdit] = useState(false);
  const [editorPic, setEditorPic] = useState();
  const [picFileInput, setPicFileInput] = useState();

  const submitData = async (mode) => {
    setLoader(true);
    let formdata = new FormData();
    formdata.append(champ, "");

    if (picFileInput && mode === "save") {
      // Conversion de l'image base64 en binaire
      let imgBase64 = "";
      imgBase64 = editorPic.getImageScaledToCanvas().toDataURL();
      var blobBin = atob(imgBase64.split(",")[1]);
      var array = [];
      for (var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }
      var file = new Blob([new Uint8Array(array)], { type: "image/png" });
      formdata.append(champ, file);
    }

    if (
      (mode === "delete" && personnalisation) ||
      (mode === "save" && picFileInput)
    ) {
      await apiUpdateInstance(ReduxInstance._id, formdata);
      const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
      if (res.data) {
        dispatch(chgInstance(res.data));
        setModeEdit(false);
        setPicFileInput("");
      }
    }
    setLoader(false);
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
  };

  return (
    <>
      {!modeEdit && (
        <>
          <Image src={defaultImg} />
          <div className="text-start mt-3">
            {personnalisation && (
              <Button
                variant="danger"
                className="me-2"
                onClick={(e) => setShowDelete(true)}
              >
                {t("commun.form.button.supprimer")}
              </Button>
            )}
            <Button onClick={(e) => setModeEdit(true)}>
              {" "}
              {t("commun.form.button.modifier")}
            </Button>
          </div>
        </>
      )}

      {modeEdit && (
        <>
          {picFileInput && (
            <div className="text-center">
              <AvatarEditor
                image={picFileInput}
                width={widthEditor ? widthEditor : 980}
                height={heightEditor ? heightEditor : 300}
                border={50}
                color={[255, 255, 255, 0.9]}
                scale={parseFloat(zoom)}
                rotate={0}
                ref={setEditorPic}
              />
              <br />
              <MdZoomOut size="3em" />
              <Form.Range
                onChange={(e) => setZoom(e.target.value)}
                value={zoom}
                min="1"
                max="3"
                step="0.1"
                style={{ width: "350px" }}
              />
              <MdZoomIn size="3em" />
            </div>
          )}
          {loader && <ComponentLoader />}
          {!loader && (
            <>
              <Form.Control
                type="file"
                onChange={(e) => setPicFileInput(e.target.files[0])}
                className="mb-3"
              />
              <Alert variant="info">
                {t("admin.PageAdminStyle.infoTaille")}{" "}
                {widthEditor ? widthEditor + "px" : "980px"} /{" "}
                {heightEditor ? heightEditor + "px" : "300px"}
              </Alert>

              <Button
                onClick={(e) => {
                  setPicFileInput("");
                  setModeEdit(false);
                }}
                variant="danger"
                className="me-2"
              >
                {t("commun.form.button.supprimer")}
              </Button>
              <Button onClick={(e) => submitData("save")} variant="success">
                {t("commun.form.button.enregistrer")}
              </Button>
            </>
          )}
        </>
      )}

      <ModalDelete
        image={defaultImg}
        show={showDelete}
        handleClose={handleCloseDelete}
        handleSubmitData={submitData}
      />
    </>
  );
};

export default ComponentUpdateApparence;
